import messages from './en.json';

const placeholderPattern = /\{\{\s*([\w.]+)\s*\}\}/g;

function replacePlaceholders(message, values) {
    return message.replace(placeholderPattern, (match, placeholderName) => {
        if (!Object.prototype.hasOwnProperty.call(values, placeholderName)) {
            return match;
        }

        const replacement = values[placeholderName];

        if (replacement === null || replacement === undefined) {
            return '';
        }

        return String(replacement);
    });
}

export function getText(key, values = {}) {
    const message = messages[key];

    if (typeof message !== 'string') {
        return key;
    }

    return replacePlaceholders(message, values);
}

export default messages;
